import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as prodAPI from '../../lib/api/prodapi';
import { takeLatest } from 'redux-saga/effects';
import { reduce, forEach } from 'lodash';

/**
 * API 서버에 Request 하는 Action Type
 */
const [
    REQ_TYPE_ELK_CATEINFO_STATS,
    REQ_TYPE_ELK_CATEINFO_STATS_SUCCESS,
    REQ_TYPE_ELK_CATEINFO_STATS_FAILURE,
] = createRequestActionTypes('prod/LIST_PROD_STATS');

const [
    REQ_TYPE_ELK_SEL_CATEINFO_STATS,
    REQ_TYPE_ELK_SEL_CATEINFO_STATS_SUCCESS,
    REQ_TYPE_ELK_SEL_CATEINFO_STATS_FAILURE,
] = createRequestActionTypes('prod/LIST_SEL_PROD_STATS');

// 상품 정보를 가져오는 API ( 카테고리, 필터 , 브랜드 정보, 현재 페이지 정보 필요)
const [
    REQ_TYPE_LIST_PROD_BY_CATE_FILTER,
    REQ_TYPE_LIST_PROD_BY_CATE_FILTER_SUCCESS,
    REQ_TYPE_LIST_PROD_BY_CATE_FILTER_FAILURE,
] = createRequestActionTypes('prod/LIST_PROD_BY_CATE_FILTER');

// 상품의 가격 통계 정보를 가져옴 
const [
    REQ_TYPE_PROD_PRICE_STATS,
    REQ_TYPE_PROD_PRICE_STATS_SUCCESS,
    REQ_TYPE_PROD_PRICE_STATS_FAILURE,
] = createRequestActionTypes('prod/PROD_PRICE_STATS');


// 상품의 옵션 가격 정보를 가져옴 
// const [
//     REQ_TYPE_PROD_OPT_PRICE,
//     REQ_TYPE_PROD_OPT_PRICE_SUCCESS,
//     REQ_TYPE_PROD_OPT_PRICE_FAILURE,
// ] = createRequestActionTypes('prod/PROD_OPT_PRICE');

//브랜드 홈 상품 정보를 가져옴
const [
    REQ_TYPE_LIST_PROD_BY_BRAND_HOME,
    REQ_TYPE_LIST_PROD_BY_BRAND_HOME_SUCCESS,
    REQ_TYPE_LIST_PROD_BY_BRAND_HOME_FAILURE,
] = createRequestActionTypes('prod/LIST_PROD_BY_BRAND_HOME');

// 상품의 옵셥별 상세 가격 정보 
const [
    REQ_TYPE_OPT_INFO,
    REQ_TYPE_OPT_INFO_SUCCESS,
    REQ_TYPE_OPT_INFO_FAILURE,
] = createRequestActionTypes('prod/REQ_TYPE_OPT_INFO');


// 내가구 견적 상품 필터 정보
const [
    REQ_TYPE_ES_FILTER_INFO,
    REQ_TYPE_ES_FILTER_INFO_SUCCESS,
    REQ_TYPE_ES_FILTER_INFO_FAILURE,
] = createRequestActionTypes('prod/REQ_TYPE_ES_FILTER_INFO');

// 내가구 견적 상품 필터 정보
const [
    REQ_TYPE_ES_COUNT_PD_FILTER_INFO,
    REQ_TYPE_ES_COUNT_PD_FILTER_INFO_SUCCESS,
    REQ_TYPE_ES_COUNT_PD_FILTER_INFO_FAILURE,
] = createRequestActionTypes('prod/REQ_TYPE_ES_COUNT_PD_FILTER_INFO');

// 내가구 상품 필터에의한 상품 정보
const [
    REQ_TYPE_ES_PROD_FILTER_INFO,
    REQ_TYPE_ES_PROD_FILTER_INFO_SUCCESS,
    REQ_TYPE_ES_PROD_FILTER_INFO_FAILURE,
] = createRequestActionTypes('prod/REQ_TYPE_ES_PROD_FILTER_INFO');

// 내가구 카테고리 가지고 있는 브랜드 정보
const [
    REQ_TYPE_ES_BRAND_FILTER_INFO,
    REQ_TYPE_ES_BRAND_FILTER_INFO_SUCCESS,
    REQ_TYPE_ES_BRAND_FILTER_INFO_FAILURE,
] = createRequestActionTypes('prod/REQ_TYPE_ES_BRAND_FILTER_INFO');

// 카테고리 상품 리스트
const [
    REQ_TYPE_PROD_FILTER_INFO,
    REQ_TYPE_PROD_FILTER_INFO_SUCCESS,
    REQ_TYPE_PROD_FILTER_INFO_FAILURE,
] = createRequestActionTypes('prod/REQ_TYPE_PROD_FILTER_INFO');

//카테고리 필터 정보 (카테고리 1,2 id 기준)
const [
    REQ_TYPE_CATEGORY_FILTER_INFO,
    REQ_TYPE_CATEGORY_FILTER_INFO_SUCCESS,
    REQ_TYPE_CATEGORY_FILTER_INFO_FAILURE,
] = createRequestActionTypes('prod/REQ_TYPE_CATEGORY_FILTER_INFO');

//카테고리의 가격 변동에 따른 상품 개수 (카테고리 1,2 id기준)
const [
    REQ_TYPE_COUNT_CATEGORY_PRICE_INFO,
    REQ_TYPE_COUNT_CATEGORY_PRICE_INFO_SUCCESS,
    REQ_TYPE_COUNT_CATEGORY_PRICE_INFO_FAILURE,
] = createRequestActionTypes('prod/REQ_TYPE_COUNT_CATEGORY_PRICE_INFO');

const RESET_OPT_INFO = 'prod/RESET_OPT_INFO';

// 컴포넌트에서 사용할 선택된 상품 설정 액션
const REQ_TYPE_SET_PROD_SELECTED = 'prod/SET_PROD_SEL';

// 상품 가격 설정 Min / Max 
const SET_PRICE = 'prod/SET_PRICE';

//카테고리 필터 변경시 저장할 상품 max/min 값
const SET_MAXMIN_PRICE = 'prod/SET_MAXMIN_PRICE';

const SET_READY = 'prod/SET_READY'

// 선택된 상품의 선택된 옵션 정보 
const REQ_TYPE_SET_OPTION_SELECTED = 'prod/SET_PROD_OPTION_SET';

const REQ_TYPE_COUNT_CATEGORY_PRICE_RESET = 'prod/REQ_TYPE_COUNT_CATEGORY_PRICE_RESET';
/**
 * 견적서 요청 Action - Container 에서 요청 
 * 첫번째 인자 - ActionType
 * 두번째 인자 - 리듀서에서 처리 해야 할 Payload : 스토어에서 사용될 값 (생략가능)
 */
export const getElkCateStatsInfoAction = createAction(REQ_TYPE_ELK_CATEINFO_STATS, (cateItems, brandId) => {
    return ({ cateItems, brandId })
}
);

// 선택된 카테고리별 통계 정보 
export const getElksSelCateStatsInfoAction = createAction(REQ_TYPE_ELK_SEL_CATEINFO_STATS, (cateItems, brandId) => {
    return ({ cateItems, brandId })
}
);

// 상품정보 가져오기 - 3Depth CateIds, Filter 
export const getElkProdsAction = createAction(REQ_TYPE_LIST_PROD_BY_CATE_FILTER, (cateItems, brandId, filterItems, curPage, cate2Id, prodPrice) => {
    return ({ cateItems, brandId, filterItems, curPage, cate2Id, prodPrice })
}
);

// 상품의 가격 통계 정보를 가져옴 
export const getElkProdsPriceStatsAction = createAction(REQ_TYPE_PROD_PRICE_STATS, (brandId, cate2Id) => {
    return ({ brandId, cate2Id })
}
);

// 상품의 옵션 가격을 가져옴 
// export const getProdOptionAction = createAction(REQ_TYPE_PROD_OPT_PRICE, (optioninfo) => {
//     return ({ optioninfo })
// }
// );

export const getBrandHomeProdsAction = createAction(REQ_TYPE_LIST_PROD_BY_BRAND_HOME, (cateId, brandId, filterItems, curPage, minprice, maxprice, sort) => {
    return ({ cateId, brandId, filterItems, curPage, minprice, maxprice, sort })
}
);

// 상품 옵션 정보 가져오기 
export const getProdOptPriceAction = createAction(REQ_TYPE_OPT_INFO, (prodid, opt1, opt2) => {
    return ({ prodid, opt1, opt2 })
}
);

// 내가구 견적 상품 필터 정보
export const getEsFilterInfoAction = createAction(REQ_TYPE_ES_FILTER_INFO, (cateId, brandIds) => {
    return ({ cateId, brandIds })
}
);

// 내가구 견적에서 팝업에서 필터 정보 바뀔때 상품 개수.
export const getEsCountPDFilterInfoAction = createAction(REQ_TYPE_ES_COUNT_PD_FILTER_INFO, (cate_id_list, filter, cate3Ids, minprice, maxprice, brandIds, search) => {
    return ({ cate_id_list, filter, cate3Ids, minprice, maxprice, brandIds, search })
}
);

//내가구 상품 필터에의한 상품 정보
export const getEsProdFilterInfoAction = createAction(REQ_TYPE_ES_PROD_FILTER_INFO, (cate_id_list, filter, cate3Ids, minprice, maxprice, brandIds, curpage, sort, mobile) => {
    return ({ cate_id_list, filter, cate3Ids, minprice, maxprice, brandIds, curpage, sort, mobile })
}
);

// 내가구 견적에서 팝업에서 필터 정보 바뀔때 상품 개수.
export const getEsBrandilterInfoAction = createAction(REQ_TYPE_ES_BRAND_FILTER_INFO, (cate_id_list, brandIds) => {
    return ({ cate_id_list, brandIds })
}
);

//카테고리 상품 필터에의한 상품 정보
export const getProdFilterInfoAction = createAction(REQ_TYPE_PROD_FILTER_INFO, (cate1Id, cate2Id, filter, cate3Ids, minprice, maxprice, brandIds, curpage, sort, mobile, search) => {
    return ({ cate1Id, cate2Id, filter, cate3Ids, minprice, maxprice, brandIds, curpage, sort, mobile, search })
}
);

//카테고리 필터정보 (카테고리 1,2 id 기준)
export const getCategoryFilterInfoAction = createAction(REQ_TYPE_CATEGORY_FILTER_INFO, (cate1Id, cate2Id, brandIds, search) => {
    return ({ cate1Id, cate2Id, brandIds, search })
}
);

export const getCategoryCountFromPriceInfoAction = createAction(REQ_TYPE_COUNT_CATEGORY_PRICE_INFO, (cate1Id, cate2Id, brandIds, minprice, maxprice, search) => {
    return ({ cate1Id, cate2Id, brandIds, minprice, maxprice, search })
}
);

// 상품 옵션 정보 Reset
export const resetOptPriceAction = createAction(RESET_OPT_INFO);

// 컴포넌트에서 사용할 선택된 상품 설정 액션
export const setSelProdInfoAction = createAction(REQ_TYPE_SET_PROD_SELECTED);

// 상품 가격 설정 Min / Max 
export const setPriceAction = createAction(SET_PRICE);
export const setMaxMinPriceAction = createAction(SET_MAXMIN_PRICE);
export const setReadyAction = createAction(SET_READY);

//  선택된 상품의 선택된 옵션 정보 
export const setSelOptionInfoAction = createAction(REQ_TYPE_SET_OPTION_SELECTED);

//카테고리 가격 변동에 대한 개수 초기화
export const resetCountPriceAction = createAction(REQ_TYPE_COUNT_CATEGORY_PRICE_RESET);

/**
 * SAGA API 에서 REST API 호출 
 */
const elkCateStatsInfoSaga = createRequestSaga(REQ_TYPE_ELK_CATEINFO_STATS, prodAPI.getElkCateStatsInfo);
const elkProdsSaga = createRequestSaga(REQ_TYPE_LIST_PROD_BY_CATE_FILTER, prodAPI.getElkProds);
const elkPriceStatsSaga = createRequestSaga(REQ_TYPE_PROD_PRICE_STATS, prodAPI.getElkPriceStats);
// const getOptionPriceSaga = createRequestSaga(REQ_TYPE_PROD_OPT_PRICE, prodAPI.getOptionPrice);
const brandHomeProdsSaga = createRequestSaga(REQ_TYPE_LIST_PROD_BY_BRAND_HOME, prodAPI.getBrandHomeProds);
const getProdOptPriceSaga = createRequestSaga(REQ_TYPE_OPT_INFO, prodAPI.getProdOptPrice);
const getEsFilterInfoSaga = createRequestSaga(REQ_TYPE_ES_FILTER_INFO, prodAPI.getEsFilterInfo);
const getEsCountPDFilterInfoSaga = createRequestSaga(REQ_TYPE_ES_COUNT_PD_FILTER_INFO, prodAPI.getEsCountPDFilterInfo);
const getEsProdFilterInfoSaga = createRequestSaga(REQ_TYPE_ES_PROD_FILTER_INFO, prodAPI.getEsProdFilterInfo);
const getEsBrandilterInfoSaga = createRequestSaga(REQ_TYPE_ES_BRAND_FILTER_INFO, prodAPI.getEsBrandFilterInfo);
const getProdFilterInfoSaga = createRequestSaga(REQ_TYPE_PROD_FILTER_INFO, prodAPI.getProdFilterInfo);
const getCategoryFilterInfoSaga = createRequestSaga(REQ_TYPE_CATEGORY_FILTER_INFO, prodAPI.getCategoryFilterInfo);
const getCategoryCountFromPriceInfoSaga = createRequestSaga(REQ_TYPE_COUNT_CATEGORY_PRICE_INFO, prodAPI.getCategoryCountFromPriceInfo);

export function* elkCateInfoItemsSaga() {
    yield takeLatest(REQ_TYPE_ELK_CATEINFO_STATS, elkCateStatsInfoSaga);
    yield takeLatest(REQ_TYPE_LIST_PROD_BY_CATE_FILTER, elkProdsSaga);
    yield takeLatest(REQ_TYPE_PROD_PRICE_STATS, elkPriceStatsSaga);
    // yield takeLatest(REQ_TYPE_PROD_OPT_PRICE, getOptionPriceSaga);
    yield takeLatest(REQ_TYPE_LIST_PROD_BY_BRAND_HOME, brandHomeProdsSaga);
    yield takeLatest(REQ_TYPE_OPT_INFO, getProdOptPriceSaga);
    yield takeLatest(REQ_TYPE_ES_FILTER_INFO, getEsFilterInfoSaga);
    yield takeLatest(REQ_TYPE_ES_COUNT_PD_FILTER_INFO, getEsCountPDFilterInfoSaga);
    yield takeLatest(REQ_TYPE_ES_PROD_FILTER_INFO, getEsProdFilterInfoSaga);
    yield takeLatest(REQ_TYPE_ES_BRAND_FILTER_INFO, getEsBrandilterInfoSaga);
    yield takeLatest(REQ_TYPE_PROD_FILTER_INFO, getProdFilterInfoSaga);
    yield takeLatest(REQ_TYPE_CATEGORY_FILTER_INFO, getCategoryFilterInfoSaga);
    yield takeLatest(REQ_TYPE_COUNT_CATEGORY_PRICE_INFO, getCategoryCountFromPriceInfoSaga);
}


/**
 * Store에 저장될 값 
 */
const initialState = {
    prodStats: null, // 상품 카테고리 통계 정보 
    selectedProdStats: null, // 선택된 카테고리별 통계 정보 
    priceStats: null, // 상품 가격 통계 정보 
    prodItems: null, // 상품 정보 
    selectedProdItem: null, // 선택된 상품 정보 
    selectedOptionItems: [], // 선택된 옵션 정보 
    error: null,
    prodPrice: { min: 0, max: 0 }, // 선택한 옵션 정보 
    optInfo1: null, // 옵션1 정보 
    optInfo2: null, // 옵션2 정보 
    optInfo3: null, // 옵션3 정보 
    ready:false, //가격 필터 max/min 업데이트 여부
    prodMaxMinPrice: { min: 0, max: 0 }, // 선택한 옵션 정보 
    esFilterInfo: null, //내가구 견적에서 상품에 대한 필터 정보
    esCountProdFromFilter:null, //내가구 견적에서 팝업에서 필터 정보 바뀔때 상품 개수 및 필터 정보.
    esProdItems: null, // 내가구 견적 상품 정보 
    esBrandFilterInfo:null, //내가구 견적 4단계에서 카테고리 포함한 브랜드
    categoryFilterInfo: null, //카테고리 필터 정보 (가격,필터 등 카테고리 1,2 아이디 기준)
    countFromPriceCategory: null, //카테고리 가격만으로 상품 개수 가져오기.
}

const prodItemsReducer = handleActions(
    {
        [REQ_TYPE_ELK_CATEINFO_STATS_SUCCESS]: (state, { payload: prodStats }) => {
            return ({
                ...state,
                prodStats,
            });
        },
        [REQ_TYPE_ELK_CATEINFO_STATS_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_ELK_SEL_CATEINFO_STATS_SUCCESS]: (state, { payload: selectedProdStats }) => {
            return ({
                ...state,
                selectedProdStats,
            });
        },
        [REQ_TYPE_ELK_SEL_CATEINFO_STATS_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_LIST_PROD_BY_CATE_FILTER_SUCCESS]: (state, { payload: prodItems }) => {
            // 요청이 왔는데, curpage 
            return ({
                ...state,
                prodItems,
            });
        },
        [REQ_TYPE_LIST_PROD_BY_CATE_FILTER_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_PROD_PRICE_STATS_SUCCESS]: (state, { payload: priceStats }) => {
            return ({
                ...state,
                priceStats,
            });
        },
        [REQ_TYPE_PROD_PRICE_STATS_FAILURE]: (state, { payload: error }) => {
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_SET_PROD_SELECTED]: (state, { payload: selectedProdItem }) => ({
            ...state,
            selectedProdItem: selectedProdItem,
            selectedOptionItems: [],
        }),
        [SET_PRICE]: (state, { payload: prodPrice }) => ({
            ...state,
            prodPrice,
        }),
        [REQ_TYPE_SET_OPTION_SELECTED]: (state, { payload: selectedOptionItems }) => {

            // console.log("prodModule : " + JSON.stringify(selectedOptionItems));

            return ({
                ...state,
                selectedOptionItems,
            });
        },
        [REQ_TYPE_LIST_PROD_BY_BRAND_HOME_SUCCESS]: (state, { payload: prodItems }) => {
            // 요청이 왔는데, curpage 
            return ({
                ...state,
                prodItems,
            });
        },
        [REQ_TYPE_LIST_PROD_BY_BRAND_HOME_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_OPT_INFO_SUCCESS]: (state, { payload }) => {

            // console.log("payload : " + JSON.stringify(payload));

            let reduceItem = [];

            forEach(payload.value, (curItem, index) => {
                // console.log("key : " + curItem.key);
                let tmpObj = { label: curItem.key, id: null, price: 0, status: 1 };
                if (payload.isnext === false) {

                    tmpObj.id = curItem.value[0].id;
                    tmpObj.price = curItem.value[0].opt_price;
                    tmpObj.status = curItem.value[0].opt_status;
                }
                reduceItem.push(tmpObj);
            })

            // console.log("reduceItem : " + JSON.stringify(reduceItem));

            if (payload.idx === 1) {
                state.optInfo1 = reduceItem;
            } else if (payload.idx === 2) {
                state.optInfo2 = reduceItem;
            } else {
                state.optInfo3 = reduceItem;
            }

            return ({
                ...state,
            });
        },
        [REQ_TYPE_OPT_INFO_FAILURE]: (state, { payload: error }) => {
            return ({
                ...state,
                error,
            });
        },
        [RESET_OPT_INFO]: (state) => {
            return ({
                ...state,
                optInfo1: null,
                optInfo2: null,
                optInfo3: null
            });
        },
        [SET_READY]: (state, { payload: ready }) => ({
            ...state,
            ready: ready,
        }),
        [SET_MAXMIN_PRICE]: (state, { payload: prodMaxMinPrice }) => ({
            ...state,
            prodMaxMinPrice: prodMaxMinPrice,
        }),
        [REQ_TYPE_ES_FILTER_INFO_SUCCESS]: (state, { payload: esFilterInfo }) => {
            return ({
                ...state,
                esFilterInfo,
            });
        },
        [REQ_TYPE_ES_FILTER_INFO_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_ES_COUNT_PD_FILTER_INFO_SUCCESS]: (state, { payload: esCountProdFromFilter }) => {
            //console.log("REQ_TYPE_ES_COUNT_PD_FILTER_INFO_SUCCESS : " + JSON.stringify(esCountProdFromFilter));
            return ({
                ...state,
                esCountProdFromFilter,
            });
        },
        [REQ_TYPE_ES_COUNT_PD_FILTER_INFO_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_ES_PROD_FILTER_INFO_SUCCESS]: (state, { payload: esProdItems }) => {
            //console.log("REQ_TYPE_ES_PROD_FILTER_INFO_SUCCESS = " + JSON.stringify(esProdItems))
            // 요청이 왔는데, curpage 
            return ({
                ...state,
                esProdItems,
            });
        },
        [REQ_TYPE_ES_PROD_FILTER_INFO_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_ES_BRAND_FILTER_INFO_SUCCESS]: (state, { payload: esBrandFilterInfo }) => {
            //console.log("REQ_TYPE_ES_COUNT_PD_FILTER_INFO_SUCCESS : " + JSON.stringify(esCountProdFromFilter));
            return ({
                ...state,
                esBrandFilterInfo:esBrandFilterInfo.brand.buckets,
            });
        },
        [REQ_TYPE_ES_BRAND_FILTER_INFO_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_PROD_FILTER_INFO_SUCCESS]: (state, { payload: prodItems }) => {
            //console.log("REQ_TYPE_PROD_FILTER_INFO_SUCCESS = " + JSON.stringify(esProdItems))
            // 요청이 왔는데, curpage 
            return ({
                ...state,
                prodItems,
            });
        },
        [REQ_TYPE_PROD_FILTER_INFO_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_CATEGORY_FILTER_INFO_SUCCESS]: (state, { payload: categoryFilterInfo }) => {
            return ({
                ...state,
                categoryFilterInfo,
            });
        },
        [REQ_TYPE_CATEGORY_FILTER_INFO_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_COUNT_CATEGORY_PRICE_INFO_SUCCESS]: (state, { payload: countFromPriceCategory }) => {
            return ({
                ...state,
                countFromPriceCategory,
            });
        },
        [REQ_TYPE_COUNT_CATEGORY_PRICE_INFO_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [REQ_TYPE_COUNT_CATEGORY_PRICE_RESET]: (state) => {
            return ({
                ...state,
                countFromPriceCategory: null
            });
        },
    }
    , initialState);

export default prodItemsReducer;
